
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { GiEvilMoon, GiHeraldicSun } from "react-icons/gi";
import { TbSunMoon } from "react-icons/tb";

const ThemeContext = createContext({});

function ThemeInfo({ children }) {
  const [rerender, setRerender] = useState(false)

  const rerenderPage = () => {
    setRerender(prevState => !prevState)
  }

  function handleTheme(e) {
    switch (e) {
      case 'default':
        localStorage.removeItem("theme");
        rerenderPage()
        break;
      case 'dark':
        localStorage.theme = "dark";
        rerenderPage()
        break;
      case 'light':
        localStorage.theme = "light";
        rerenderPage()
        break;

      default:
        break;
    }
  }

  const itemsTheme = [
    {
      label: "Usar padrão",
      icon: <TbSunMoon className="mr-2 text-xl" />,
      value: "AP",
      command: () => handleTheme('default')
    },
    {
      label: "Escuro",
      icon: <GiEvilMoon className="mr-2 text-xl" />,
      value: "AP",
      command: () => handleTheme('dark')
    },
    {
      label: "Claro",
      icon: <GiHeraldicSun className="mr-2 text-xl" />,
      value: "AP",
      command: () => handleTheme('light')
    },
  ]

  useEffect(() => {
    //console.log(localStorage.getItem('theme'))
    if (
      localStorage.getItem('theme') === 'dark' ||
      (!('theme' in localStorage) &&
        window.matchMedia('(prefers-color-scheme: dark)').matches)
    ) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [rerender])

  return (
    <ThemeContext.Provider
      value={{
        itemsTheme,
        rerenderPage
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

function useTheme() {
  return useContext(ThemeContext);
}

export { useTheme, ThemeInfo }
